// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-icon__wrapper {
  display: flex;
  margin-bottom: 1rem;
}
.live-icon__content {
  display: inline-block;
  padding: 0 0.3rem;
  border: 1px solid #dddddd;
  border-radius: 1rem;
}
.live-icon__content .ant-badge-color-red {
  animation: blink 2s infinite linear;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/LiveIcon/LiveIcon.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;AAAR;AAEI;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,mCAAA;AAAZ;AAII;EACI;IACI,UAAA;EAFV;EAIM;IACI,UAAA;EAFV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
